
import {  Button, Typography,  Dialog,  DialogContent, DialogActions, DialogTitle, IconButton } from '@mui/material';
import { ScheduleCreateContext, ScheduleCreateValues } from '../../contexts/ScheduleCreateContext';
import { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const ScheduleCreateDeleteCategoryModal=() => {
  const { t,
    isCategoryDeleteModalOpen,
    handleClose,
    deleteCategories,
  } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  return (
    <Dialog open={isCategoryDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('deleteCategory')}
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute',
            right: 16,
            top: 8,
            color: (theme) => theme.palette.custom.gray[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>{t('approvalDialogMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button 
          variant="secondary"
          size='lg'
          onClick={handleClose}>
          {t('cancel')}
        </Button>
        <Button variant="bad"
          size='lg'
          onClick={deleteCategories}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleCreateDeleteCategoryModal;